import React from 'react';

import './../css/Mobile.css';

class Mobile extends React.Component {
  render(){
    return(
      <div id="mobile">
        <p>Sorry, this experiment only works in desktop Chrome and Firefox for now!</p>
      </div>
    )
  }
}

export default Mobile;


// WEBPACK FOOTER //
// ./src/js/Mobile.js